export const SearchIcon = () => {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.067 6.88677C10.067 9.11441 8.26114 10.9203 6.0335 10.9203C3.80586 10.9203 2 9.11441 2 6.88677C2 4.65913 3.80586 2.85327 6.0335 2.85327C8.26114 2.85327 10.067 4.65913 10.067 6.88677ZM9.5885 11.7622C8.59149 12.4905 7.36269 12.9203 6.0335 12.9203C2.70129 12.9203 0 10.219 0 6.88677C0 3.55456 2.70129 0.853271 6.0335 0.853271C9.36571 0.853271 12.067 3.55456 12.067 6.88677C12.067 8.16774 11.6678 9.35547 10.987 10.3323L14.0944 13.4397C14.485 13.8303 14.485 14.4634 14.0944 14.854C13.7039 15.2445 13.0707 15.2445 12.6802 14.854L9.5885 11.7622Z"
        fill="inherit"
      ></path>
    </svg>
  );
};
